/** Schedule of a date-windowed singleton (banner campaign, launch widgets, …). */
export interface IScheduledCampaign {
  isEnabled?: boolean;
  startDate?: string;
  endDate?: string;
}

export type CampaignState =
  | "disabled"
  | "missingDates"
  | "scheduled"
  | "live"
  | "ended";

const toTime = (value?: string) => (value ? new Date(value).getTime() : NaN);

/**
 * Where a campaign stands at `now`. Start is inclusive, end exclusive, and missing or
 * invalid dates are never live. Comparisons run on epoch ms, so timezones don't matter.
 */
export function getCampaignState(
  config: IScheduledCampaign | null | undefined,
  now: number = Date.now(),
): CampaignState {
  if (!config?.isEnabled) return "disabled";
  const start = toTime(config.startDate);
  const end = toTime(config.endDate);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return "missingDates";
  if (now < start) return "scheduled";
  return now < end ? "live" : "ended";
}

/** Live when enabled and `now` ∈ [startDate, endDate). */
export function isCampaignWindowLive(
  config: IScheduledCampaign | null | undefined,
  now: number = Date.now(),
): boolean {
  return getCampaignState(config, now) === "live";
}
